import { Component, ChangeDetectionStrategy, OnDestroy, Inject, ChangeDetectorRef } from "@angular/core";
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from "@angular/material/core";
import { MatCalendar } from "@angular/material/datepicker";
import { Subject, takeUntil } from "rxjs";

/** Custom header component for datepicker. */
@Component({
    selector: 'custom-date-picker-header',
    styleUrls: ['./custom-date-picker-header.sass'],
    templateUrl: './custom-date-picker-header.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
  export class CustomDatePickerHeader<D> implements OnDestroy {
    private _destroyed = new Subject<void>();
  
    constructor(
      private _calendar: MatCalendar<D>,
      private _dateAdapter: DateAdapter<D>,
      @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
      cdr: ChangeDetectorRef,
    ) {
      _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => cdr.markForCheck());
    }
  
    ngOnDestroy() {
      this._destroyed.next();
      this._destroyed.complete();
    }
  
    get periodLabel() {
      let currentMonth = this._dateAdapter.format(this._calendar.activeDate, this._dateFormats.display.monthLabel);
      let currentYear = this._dateAdapter.format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel);
      return this.toTitleCase(currentMonth) + ' ' + currentYear;
    }
  
    toTitleCase(text: string){
       return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
    }

    previousClicked() {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1);
    }
  
    nextClicked() {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1);
    }
  }